import React, { useEffect,useState } from 'react';
import { Input } from 'reactstrap';
import './index.scss';

const PdfPageDropdown = ({ pdfPagesCount, handleVal, val = '', loader }) => {
	const handleOnChange = (event) => {
		handleVal(Number(event.target.value));
	};
	const [value,setValue] = useState(val)

	const options = [];
	for (let i = 1; i <= pdfPagesCount; i++) {
		options.push(<option selected={i==val} value={i}>
			{i}</option>);
	}

	return (
		<div className='d-inline-flex align-items-center pdf-page-counter'>
			<div className='select-cell flex-fill flex-shrink-0'>
				<select onChange={handleOnChange} className='form-control form-select'>
					{options}
				</select>
			</div>
			<label>Of {pdfPagesCount}</label>
		</div >
	)
}

export default PdfPageDropdown;